'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var culture = {
  'model': {

    'serviceType': {
      'title': 'Sottomenù',
      'type': 'select',
      'enum': ['INFO_TURISMO', 'GUIDE', 'RISTORAZIONE', 'DORMIRE', 'NUMERI_UTILI', 'TOUR_OPERATOR'],
      'prefix': 'vm.item.service',
      'required': true
    },

    'title': {
      'title': 'Titolo',
      'type': 'input',
      'prefix': 'lang',
      'required': true
    },

    'municipality': {
      'title': 'Comune',
      'type': 'input',
      'prefix': 'vm.item.service',
      'required': false
    },

    'category': {
      'title': 'Categoria',
      'type': 'input',
      'prefix': 'vm.item.service',
      'required': false
    },

    'phoneNumber': {
      'title': 'Numero di telefono',
      'type': 'input',
      'prefix': 'vm.item.service'
    },

    'eMail': {
      'title': 'E-mail',
      'type': 'input',
      'prefix': 'vm.item.service'
    },

    'webSite': {
      'title': 'Sito web',
      'type': 'input',
      'prefix': 'vm.item.service'
    },

    'description': {
      'title': 'Descrizione',
      'type': 'editor',
      'prefix': 'lang',
      'row': 8
    },

    'location': {
      'title': 'Ubicazione',
      'type': 'input',
      'prefix': 'lang',
      'required': true
    },

    'timetable': {
      'title': 'Orari e stagionalità',
      'type': 'input',
      'prefix': 'lang'
    },

    'note': {
      'title': 'Note',
      'type': 'editor',
      'prefix': 'lang',
      'row': 2
    },

    'additionalInformations': {
      'title': 'Approfondisci',
      'type': 'editor',
      'prefix': 'lang',
      'row': 2
    }
  }
};

exports.default = culture;


// WEBPACK FOOTER //
// ./client/app/common/factories/modelFactory/service.model.js